module.exports = __webpack_public_path__ + "static/img/banner_intro.ccc941c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_intro.jpg
// module id = RYW/
// module chunks = 2